import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import INSPIRATIONTEMPLATEAPI from "../../Api/InspirationTemplate";
import EventBus from "../../utils/EventBus";
import { setMessage } from "./message";



export const fetchInspirationTemplates = createAsyncThunk("template/fetchInspirationTemplates", async (params, thunkAPI) => {
    try {
        const response = await INSPIRATIONTEMPLATEAPI.getInspirationTemplates(params);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

export const fetchInspirationTemplatesById = createAsyncThunk("template/fetchInspirationTemplates", async (id, thunkAPI) => {
    try {
        const response = await INSPIRATIONTEMPLATEAPI.getInspirationTemplatesById(id);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});



export const addTemplate = createAsyncThunk("template/addTemplate", async (formData, thunkAPI) => {
    try {
        const response = await INSPIRATIONTEMPLATEAPI.addInspirationTemplate(formData);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});



export const updateInspirationTemplate = createAsyncThunk("template/updateTemplate", async ({ id, formData }, thunkAPI) => {
    try {
        const response = await INSPIRATIONTEMPLATEAPI.updateInspirationTemplate(id, formData);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});


export const deleteTemplate = createAsyncThunk("template/deleteTemplate", async (id, thunkAPI) => {
    try {
        const response = await INSPIRATIONTEMPLATEAPI.deleteInspirationTemplate(id);
        return id;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});

const InspirationtemplateSlice = createSlice({
    name: "Inspirationtemplate",
    initialState: {
        Inspirationtemplates: [],
        error: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInspirationTemplates.fulfilled, (state, action) => {
                console.log(action.payload.data)
                state.Inspirationtemplates = action.payload.data;
            })
            .addCase(addTemplate.fulfilled, (state, action) => {
                state.Inspirationtemplates.push(action.payload.data);
            })
            .addCase(updateInspirationTemplate.fulfilled, (state, action) => {
                const {
                    arg: { id },
                } = action.meta;
                if (id) {
                    state.Inspirationtemplates = state.Inspirationtemplates.map((template) =>
                        template._id === id ? action.payload.data : template
                    );

                }
            })

            .addCase(deleteTemplate.fulfilled, (state, action) => {
                state.Inspirationtemplates = state.Inspirationtemplates.filter((template) => template.id !== action.payload);
            })
            .addCase(fetchInspirationTemplates.rejected, (state, action) => {
                state.Inspirationtemplates=[]
                state.error = action.payload;
            })
            .addCase(addTemplate.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(updateInspirationTemplate.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(deleteTemplate.rejected, (state, action) => {
                state.error = action.payload;
            });
    },
});

const { reducer } = InspirationtemplateSlice;
export default reducer;
